import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/clientdashboard/_layout/stripe/checkout")({
  validateSearch: z.object({
    transactionIds: z.number().array().default([]),
  }),
});
